import axios from 'axios';

import { getCookie } from '@utils/getCookie';

const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = getCookie('SU_AUTH');
    const crsfToken = getCookie('csrftoken');

    if (token) {
      config.headers.Authorization = `Token ${token}`;
    }

    if (crsfToken) {
      config.headers['X-CSRFToken'] = crsfToken;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);


export default axiosInstance;
